export const PRETRIP_DETAILS_TAB_ID = "Pretrip-Details";
export const PRETRIP_APPROVERS_TAB_ID = "Pretrip-Approvers";